import { useState, useRef } from 'react';
import Loader from 'components/loader';
import { ReactSVG } from 'react-svg';
import * as S from './styles';
import { toast } from 'common/helpers/toastConfig';
import { useActions } from 'common/hooks/useActions';

interface ImageUploaderProps {
  setImage: (image: string | null) => void;
  defaultImage?: string | null;
  setValues: any;
  values: any;
}

const MAX_FILE_SIZE_MB = 2;

const ImageUploader: React.FC<ImageUploaderProps> = ({ setImage, defaultImage, setValues, values }) => {
  const [isUploading] = useState(false);
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const { cafeteriaUploadRequestAction } = useActions();

  const handleFileInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];

    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > MAX_FILE_SIZE_MB) {
      toast({ model: 'error', message: 'File is too big. Maximum allowed size is 2MB.' });
      return;
    }

    const fileDataURL = await getFileDataURL(file);

    cafeteriaUploadRequestAction({ image: file }, (fileNameOnly: string) => {
      setValues({
        ...values,
        imageName: file,
        fileUrl: fileDataURL,
        name: fileNameOnly
      });
      setImage(values.fileUrl);
    });
  };

  const getFileDataURL = (file: File) => {
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result as string);
        setLogoPreview(reader.result as string);
      };
    });
  };

  return (
    <div>
      <label htmlFor="fileInput" style={{ width: '76px', height: '76px', overflow: 'hidden' }}>
        <input
          id="fileInput"
          type="file"
          accept=".png, .jpg, .jpeg, .heic"
          onChange={handleFileInputChange}
          ref={fileInputRef}
          style={{ display: 'none' }}
        />
        {isUploading ? (
          <Loader />
        ) : logoPreview ? (
          <S.ImageContainer>
            <S.Image src={logoPreview} alt="Logo" />
          </S.ImageContainer>
        ) : defaultImage ? (
          <S.ImageContainer>
            <S.Image src={defaultImage} alt="Logo" />
          </S.ImageContainer>
        ) : (
          <S.DefaultImage>
            <ReactSVG
              src={'/icons/gallery-add.svg'}
              beforeInjection={(svg) => {
                svg.setAttribute('width', `40px`);
                svg.setAttribute('height', `40px`);
              }}
            />
          </S.DefaultImage>
        )}
      </label>
    </div>
  );
};

export default ImageUploader;
